module.exports = __webpack_public_path__ + "0bf1f30287c674c3e138800ee16f0dbc.pdf";